"use client";
import { useState, useEffect } from "react";
import { useTheme } from "next-themes";
import { FaMoon, FaSun } from "react-icons/fa6";

export default function ThemeToggle() {
    const [mounted, setMounted] = useState(false);
    const { theme, setTheme } = useTheme();

    useEffect(() => {
        setMounted(true);
    }, []);

    if (!mounted) return null;

    return (
        <button
            onClick={() => {
                setTheme(theme === "dark" ? "light" : "dark");
            }}
            className={`rounded-full relative w-20 h-10 transition-normal ${
                theme === "light"
                    ? "bg-neutral-300 text-neutral-300"
                    : "bg-neutral-800 text-neutral-300"
            }`}
        >
            <div
                className={`absolute transition-normal flex items-center justify-center w-8 h-8 rounded-full top-1 bg-rose-800 ${
                    theme === "light" ? "mx-1" : "mx-11"
                }`}
            >
                {theme === "dark" ? <FaMoon /> : <FaSun />}
            </div>
        </button>
    );
}
